import { render, staticRenderFns } from "./EnvioComandosSMSPantalla.vue?vue&type=template&id=610c4336&scoped=true&"
import script from "./EnvioComandosSMSPantalla.vue?vue&type=script&lang=ts&"
export * from "./EnvioComandosSMSPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c4336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('610c4336', component.options)
    } else {
      api.reload('610c4336', component.options)
    }
    module.hot.accept("./EnvioComandosSMSPantalla.vue?vue&type=template&id=610c4336&scoped=true&", function () {
      api.rerender('610c4336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/EnvioComandosSMS/EnvioComandosSMSPantalla.vue"
export default component.exports